import { useQuery } from "@tanstack/react-query";
import {
  CsobCompanyInfoDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_CSOB } from "../domain";

import { csobHubApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_CURRENT_COMPANY_INFO = "GET_CURRENT_COMPANY_INFO";

const allowedRoles = [UserRole.Owner];

const getCurrentCsobCompanyInfo = async (): Promise<CsobCompanyInfoDto> => {
  const response = await csobHubApi.csobHubControllerGetCurrentCsobCompanyInfo();

  return response.data;
};

export const useGetCurrentCsobCompanyInfo = (
  user: UserProfileDto | null,
): {
  currentCsobCompanyInfo?: CsobCompanyInfoDto;
  currentCsobCompanyInfoEnabled: boolean;
  isPendingGetCurrentCsobCompanyInfo: boolean;
  refetchIsGetCurrentCsobCompanyInfo: () => void;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isPending, refetch } = useQuery({
    queryKey: [DOMAIN_CSOB, ACTION_GET_CURRENT_COMPANY_INFO],
    queryFn: getCurrentCsobCompanyInfo,
    staleTime: TANSTACK_QUERY_STALE_TIME,
  });

  return {
    currentCsobCompanyInfo: data,
    currentCsobCompanyInfoEnabled: enabled,
    isPendingGetCurrentCsobCompanyInfo: isPending,
    refetchIsGetCurrentCsobCompanyInfo: refetch,
  };
};
